export const title = 'Something happened.';
export const contactSupport = "If you believe there's an error please <Link>contact support</Link>";
